import { type DashboardData, type DashboardPreset, mapDashboardResponse } from "../types/dashboard";
import api from "./axios";

const omitEmpty = (params: Record<string, string | undefined>): Record<string, string> => {
  const entries = Object.entries(params).filter(
    (entry): entry is [string, string] => entry[1] !== undefined && entry[1] !== "",
  );
  return Object.fromEntries(entries);
};

export const getDashboardApi = async (
  params: {
    preset: DashboardPreset;
    from?: string;
    to?: string;
    teamOperationsId?: string;
  },
  options?: { signal?: AbortSignal },
): Promise<DashboardData> => {
  try {
    const response = await api.get("/api/v1/dashboard", {
      params: omitEmpty(params),
      signal: options?.signal,
    });
    return mapDashboardResponse(response.data);
  } catch (error) {
    console.error("Error fetching dashboard:", error);
    throw error;
  }
};
